
  <span>
    <i *ngIf="icon && !icon.startsWith('custom_')" [ngClass]="icon"></i>
    <img *ngIf="icon && icon.startsWith('custom_')" [src]="'/assets/icons/custom/' + iconFile" class="equipment-icon">
  </span>
